class SpecimenStateService {
  constructor({ axios }) {
    this.axios = axios;
    this.url = '/api/biobank/specimen-states';
  }

  async getList({ query = '', dates = [] } = {}) {
    const result = await this.axios.get(this.url, {
      params: {
        query,
        ...(Object.keys(dates).length > 0 && dates),
      },
    });
    const { data } = result;
    return data;
  }

  async getOne({ id }) {
    const { data } = await this.axios.get(`${this.url}/${id}`);
    return data;
  }

  async create({ specimenState }) {
    const { data } = await this.axios.post(this.url, specimenState);
    return data;
  }

  async update({ specimenState }) {
    const { data } = await this.axios.put(this.url, specimenState);
    return data;
  }

  async archive({ specimen }) {
    const { _id: id } = specimen;
    const { data } = await this.axios.delete(`${this.url}/archive/${id}`, { data: specimen });
    return data;
  }
}

export default SpecimenStateService;
